import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledAddBasketTitle, StyledColumnBox, StyledRowBox } from '../../theme/StyledElements';
import { PartnerProducer } from '../../models/PartnerProducer';
import { InputComponent } from '../InputComponent';

interface AddProducerPartnerProps {
    partnerProducer: PartnerProducer;
    saveProducerPartner: Function;
    index: number;
    partnerCount: string;
}

export function AddProducerPartner({
    partnerProducer,
    saveProducerPartner,
    index,
    partnerCount
}: AddProducerPartnerProps): React.ReactElement {
    const { t } = useTranslation();

    return (
        <StyledRowBox key={index}>
            <StyledColumnBox sx={{ marginRight: '20px' }}>
                <StyledAddBasketTitle variant="caption">
                    {t('nameOfProducerPartner', {
                        name: partnerCount
                    })}
                </StyledAddBasketTitle>
                <InputComponent
                    name="nom"
                    type="text"
                    placeholder={t('nameOfProducerPartner', {
                        name: partnerCount
                    })}
                    value={partnerProducer.nom}
                    onTextChange={(value: string): void => saveProducerPartner(value)}
                    width="425px"
                />
            </StyledColumnBox>
            <StyledColumnBox>
                <StyledAddBasketTitle variant="caption">
                    {t('priceOfProducts')}
                </StyledAddBasketTitle>
                <InputComponent
                    name="prix"
                    type="number"
                    placeholder={t('priceOfProducts')}
                    value={partnerProducer.prix}
                    onTextChange={(value: string): void => saveProducerPartner(parseFloat(value))}
                    width="205px"
                />
            </StyledColumnBox>
        </StyledRowBox>
    );
}
